{
  "version": 1,
  "asset_id": "5e7e5a64-68b7-4bcf-a485-930fcbc1cdf6",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/5e7e5a64-68b7-4bcf-a485-930fcbc1cdf6/karaoke-35.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/5e7e5a64-68b7-4bcf-a485-930fcbc1cdf6/karaoke-35.webp",
  "original_filename": "karaoke-35.webp",
  "size": 162310,
  "content_type": "image/webp",
  "created_at": "2026-10-12T09:40:54Z"
}
